import _styled from "@emotion/styled-base";
import * as React from "react";
import { css } from "@emotion/core";
import { space, width } from "styled-system";
import shouldForwardProp from "@styled-system/should-forward-prop";
import { em } from "../css";

var SegmentedControlContainer = /*#__PURE__*/_styled("div", {
  shouldForwardProp: shouldForwardProp,
  target: "egf3ck60"
})(function () {
  return /*#__PURE__*/css("display:flex;align-items:center;position:relative;font-size:", em(12), ";");
}, space, width);

export default SegmentedControlContainer;